import { 
  PieChart, 
  Pie, 
  Cell, 
  ResponsiveContainer,
  Tooltip
} from 'recharts';
import { ChartContainer } from './ChartContainer';

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div className="bg-card border border-primary/30 rounded-lg p-3 shadow-xl backdrop-blur-sm">
        <p className="text-sm font-manrope font-medium text-foreground">{data.source}</p>
        <p className="text-xs text-muted-foreground mt-1">
          {data.visitors.toLocaleString()} visitors ({data.percentage}%)
        </p>
      </div>
    );
  }
  return null;
};

export const SourcesChart = ({ data }) => {
  return (
    <ChartContainer 
      title="Traffic Sources" 
      subtitle="Where visitors come from"
    >
      <div className="h-[280px] w-full" data-testid="sources-chart">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="45%"
              innerRadius={60}
              outerRadius={90}
              paddingAngle={2}
              dataKey="visitors"
              stroke="none"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      
      {/* Legend */}
      <div className="space-y-2 mt-2">
        {data.map((item, index) => (
          <div key={index} className="flex items-center justify-between text-sm font-manrope">
            <div className="flex items-center gap-2">
              <div 
                className="w-3 h-3 rounded-full" 
                style={{ backgroundColor: item.color }}
              />
              <span className="text-muted-foreground">{item.source}</span>
            </div>
            <span className="text-foreground font-medium">{item.percentage}%</span>
          </div>
        ))}
      </div>
    </ChartContainer>
  );
};
